import { render, staticRenderFns } from "./FriendAssignReminder.vue?vue&type=template&id=54cf33c0&"
import script from "./FriendAssignReminder.vue?vue&type=script&lang=js&"
export * from "./FriendAssignReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports